var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"ds-tag",class:[
    ("ds-tag-size-" + _vm.size),
    ("ds-tag-" + _vm.color),
    _vm.round && 'ds-tag-round'
  ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }